/**
 * PROVENANCE: the provider and hook of C:\Horizon\web\src\components\LanguageProvider.tsx and hooks/useT.ts
 * @ 7d1c316, rebuilt here without Mantine.
 */

import { useCallback, useContext, useEffect, useMemo, useState, type ReactNode } from 'react'

import { LanguageContext, readStoredLanguage, storeLanguage, translator, type Language, type LanguageContextValue } from './core'

export function LanguageProvider({ children, initial }: { children: ReactNode; initial?: Language }) {
  const [language, setLanguageState] = useState<Language>(() => initial ?? readStoredLanguage())
  const setLanguage = useCallback((l: Language) => {
    setLanguageState(l)
    storeLanguage(l)
  }, [])
  useEffect(() => {
    document.documentElement.lang = language
  }, [language])
  const value = useMemo<LanguageContextValue>(() => ({ language, setLanguage, t: translator(language) }), [language, setLanguage])
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}

export function useLanguage(): LanguageContextValue {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error('useLanguage outside LanguageProvider')
  return ctx
}

export function useT() {
  return useLanguage().t
}
